
<div class="modal fade show" tabindex="-1" style="overflow: auto!important;">
    <div class="modal-dialog modal-xl">
        <div class="modal-content p-0">
            <div class="modal-body">
                <button type="button" (click)="close()" class="btn-close" style="position: absolute; top:15px; right: 15px; z-index: 1"></button>
                <h3 class="fs-3 fw-bold text-center mt-3 mb-0">Request Bespoke Size</h3>
                <hr class="my-4">
                <div class="px-4">

                    <div class="container h-100">
                        <div class="row g-0 h-100">
                            <div class="col-xl-12 page-min-h">
                                <app-bespoke-builder-form *ngIf="productToView" [source]="'modal'" [productToView]="productToView"></app-bespoke-builder-form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

